/**
 * @file_purpose  component created for game slider section on web page
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 01-03-2024
 */

import React, { useEffect, useState } from 'react'
import Slider from "react-slick";
import { useSelector, useDispatch } from 'react-redux'
import GeneralService from '../../apis/GeneralService';
import Constants from '../../utility/Constants';
import ApiURL from '../../apis/ApiURL';
import gameLunchHandler from '../../utility/Helpers';

const WebGameSlider = () => {

  const languageState = useSelector((state) => state.languageState);
  let languageCode = languageState.active_language.language_code;
  const userDetailState = useSelector((state) => state.userDetailState);
  let token = userDetailState?.user_details?.token ? userDetailState?.user_details?.token : ""
  var settings = {
    dots: false,
    draggable: true,
    autoplay: false, /* this is the new line */
    autoplaySpeed: 4000,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    touchThreshold: 1000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  }

  let [data, setData] = useState()

  /**
  * @author Khusir Alam
  * @Date_Created 07-03-2024
  * @Date_Modified 29/05/2025
  * @function async
  * @functionName loadGameList
  * @functionPurpose this function gets game list game category wise.
  * @functionParam {}
  * @functionSuccess Success status and message.
  * @functionError {Boolean} error is there.
  * @functionError {String} message  Description message.
  */

  async function loadGameList() {


    let params = JSON.stringify({

    })

    GeneralService.apiGetCallRequest(`${ApiURL.getFeatureGames}`, params, userDetailState.user_details.token).then(res => {

      if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {

        setData(res.data)
      }

    }).catch(error => {
    })

  }

  useEffect(() => {
    window.scrollTo(0, 0)

    loadGameList();

  }, []);

  // for game launch loader
  const [launching, setLaunching] = useState(false);
  const handleClick = (gameData, languageCode, token, play_mode) => {
    console.log('launching==>', launching);
    setLaunching(true);
    
    gameLunchHandler(gameData, languageCode, token, play_mode).finally(() => {
      console.log('launching==>', launching);
      setLaunching(false);      
    });
  }
  const demoPlayProviders = ["Boongo", "Pragmatic Play", "NetEnt", "Big Time Gaming", "Red Tiger", "Nolimit City - 94", "Nolimit City - 96", "Tap-A-Roo", "Jili", "Betsoft", "Qora", "Evoplay", "Slotopia", "Novomatic", "Penguin King", "Play N Go", "Triple Profits Games", "JDB", "Allbet", "BGaming", "Dragoon Soft", "Expanse", "Skywind", "1X2 Gaming", "Dream Gaming", "GamePlay Interactive", "Microgaming Live", "AvatarUX", "Blueprint Gaming", "Relax Gaming", "Hacksaw Gaming", "Slotmill", "Yggdrasil", "Fantasma", "Habanero", "WorldMatch", "Sigma", "Kalamba", "Mobilots", "OneTouch", "Revolver Gaming", "Realtime Gaming", "PLAYSTAR" ,"Simpleplay", "Nolimit City - 92", "WonWon", "QoraGenesis", "Qora", "Iron Dog Studio", "Kiron", "WM Casino", "Quickspin", "Thunderkick", "CosmoPlay", "EEAI"];
  return (
    <>
      <div className='slots_inn'>

        {
          data?.length > 0 ? data.map((game_category, gameIndex) => (
            game_category?.games.length > 0 &&
            <div className="slots_sec" key={gameIndex}>
              <div className="container">

                <div className="row">
                  <div className="col-sm-12">
                    <div className="slots_inn">
                      <h6>{game_category.category_name[languageCode]}</h6>

                      {

                        <>
                          <Slider {...settings} className="casino_slide">
                            {
                              game_category?.games.map((gameData, gameIndex) => (
                                // <div className='each-game-card' key={gameIndex} onClick={() => handleClick(gameData.game_code,languageCode, token)}>
                                //     <img className='each-game-card-img w-100' src={gameData.image_file_name} alt='game_card_img' />
                                //     <div className='game-detail-section'>

                                //         <span className='game-detail-playing'>{gameData?.game_name[languageCode]}</span>
                                //         <span className='game-provider-name'>{gameData?.provider_name[languageCode]}</span>
                                //     </div>
                                // </div>

                                <div className='each-game-card'>
                                  {/* Image */}
                                  <img className='each-game-card-img w-100'
                                    src={Constants.PROVIDERS_WITH_RESIZED_IMAGES.includes(gameData.provider_name) ? gameData.image_file_name.replace('/game/', '/250x250/') : gameData.image_file_name}
                                    alt='game_img'
                                  />
                                  {/* Hover buttons */}
                                  <div className="game-hover-actions">

                                    {/* Real Play always visible */}
                                    <button
                                      className="play-btn real-play"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClick(gameData, languageCode, token, 'real');
                                      }}
                                    >
                                      <i className="fa-solid fa-play"></i>
                                      Play
                                    </button>

                                    {/* Dummy Play - show only if provider is in allowed list */}
                                    {demoPlayProviders.includes(gameData.provider_name) && (
                                      <button
                                        className="play-btn dummy-play"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleClick(gameData, languageCode, token, 'fun');
                                        }}
                                      >
                                        <i className="fa-solid fa-gamepad"></i>
                                        Demo Play
                                      </button>
                                    )}

                                  </div>

                                  {/* Details */}
                                  <div className='game-detail-section'>
                                    <span className='game-detail-playing'>{gameData.game_name[languageCode]}</span>
                                    <span className='game-provider-name'>{gameData.provider_name[languageCode]}</span>
                                  </div>
                                </div>
                              ))

                            }
                          </Slider>
                        </>

                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>

          )) : ""

        }
      </div>

      {launching && (
        <div className="launch-overlay">
          <div className="launch-spinner"></div>
          <span className="launch-text">Launching your game...</span>
        </div>
      )}

      <style>{`
        .launch-btn {
          padding: 10px 16px;
          background: #28a745;
          border: none;
          color: #fff;
          border-radius: 8px;
          cursor: pointer;
          font-weight: bold;
        }

        .launch-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100vw; height: 100vh;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .launch-spinner {
          width: 60px;
          height: 60px;
          border: 8px solid #eee;
          border-top: 8px solid #28a745;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .launch-text {
          margin-top: 16px;
          color: white;
          font-size: 1.2rem;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .each-game-card {
                    position: relative;
                    overflow: hidden;
                    cursor: pointer;
                }

                .game-hover-actions {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 83%;
                    background: rgba(0,0,0,0.65);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    opacity: 0;
                    transition: opacity .3s ease;
                    gap: 10px;
                }

                .each-game-card:hover .game-hover-actions {
                    opacity: 1;
                }

                .play-btn {
                    background: #ffffff;
                    color: #000;
                    padding: 8px 14px;
                    border-radius: 8px;
                    border: none;
                    font-size: 14px;
                    display: flex;
                    gap: 6px;
                    align-items: center;
                    cursor: pointer;
                    font-weight: 600;
                }

                .play-btn:hover {
                    background: #e6e6e6;
                }

                .real-play {
                    border-left: 4px solid #28a745;
                }

                .dummy-play {
                    border-left: 4px solid #ff9800;
                }
      `}</style>
    </>
  )
}

export default WebGameSlider
